import { render } from "./Dashboard.vue?vue&type=template&id=50619916"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=50619916&lang=scss"

import exportComponent from "C:\\Users\\stall\\Documents\\Projects\\Web Apps\\Small Projects\\gmscoreboard2021-primevue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__